module.exports = __webpack_public_path__ + "static/media/vehicle-behaviour.1802d1e9.svg";